import React from 'react';

export const ReporteEjecucion = ()=>{
    return <div>
        <h1>Reporte ejecución por pantalla</h1>
    </div>
}